import { render } from "./footer.vue?vue&type=template&id=fd552c5a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=fd552c5a&scoped=true&lang=scss"

import exportComponent from "/builds/septacodeprojects/septacode.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd552c5a"]])

export default __exports__